/** JSON discriminator for `configurations.triggers[].type` (AIAgentTriggerType). */
export default Object.freeze({
  EmailReceived: 'email-received',
});
